module.exports = __webpack_public_path__ + "img/white-w-case-closed-xbox.cd985851.svg";